import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Form, Button, Table, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function HomePage() {
    const [category, setcategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [categoryId, setCategoryId] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    const [data, setdata] = useState([]);

    const [isDownload, setDownload] = useState(false);
   
    const fetchGroups = async () => {
        try {
            debugger;
            const response = await adminInstance.get("dashboard/GetDashboardSummary");
            setcategory(response.data.groups || []);
            setSubcategory(response.data.subGroups || []);
            setdata(response.data.subGroups || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const loadSubCategory = () => {
        var subGroups = subcategory.filter(s => s.GroupId == categoryId);
        debugger;
        setdata(subGroups || []);
    }

    const navigate = useNavigate();
    const goToProductPage = (subGroupId) => {
        navigate(`/Product/${subGroupId}`);
    }

    const filteredData = data
    .filter(spare =>
      spare.SubGroupName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.SubGroupCode?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    

    // const download = () => {

    //     if (!data || data.length === 0) {
    //        alert("No data to download.");
    //         return;
    //     }
    //     const updatedData = data.map((emp) => {
    //         const { UnitPriceInr = 0, TotalExpenses = 0, TotalAmountInr = 0 } = emp;

    //         const PercentExpenses = TotalAmountInr !== 0
    //             ? parseFloat(((TotalExpenses / TotalAmountInr) * 100).toFixed(2))
    //             : 0;

    //         const UnitPriceLandedCost = parseFloat(((UnitPriceInr * PercentExpenses) / 100).toFixed(2));
    //         const LandedCost = parseFloat((UnitPriceLandedCost + PercentExpenses).toFixed(2));

    //         return {
    //             ...emp,
    //             PercentExpenses,
    //             UnitPriceLandedCost,
    //             LandedCost
    //         };
    //     });

    //     console.log(updatedData);
    //     const worksheet = XLSX.utils.json_to_sheet(updatedData);

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    //     // Write Excel File
    //     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    //     // Create Blob and Trigger Download
    //     const blob = new Blob([excelBuffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });

    //     const item = ItemList.find((item) => item.id === ItemId);
    //     const itemName = item ? item.name : "Item";

    //     saveAs(blob, itemName +"-" + new Date() + ".xlsx");
    // }

    useEffect(() => {
        fetchGroups();
    }, []);

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            Product Catalog
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        <div class="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    {/* <label>Select Category</label> */}
                                    <select
                                        className="form-control sf-form-control"
                                        value={categoryId}
                                        onChange={(e) => setCategoryId(e.target.value)}
                                    >
                                        <option value="">Select Category</option>
                                        {category && category.length > 0 && category?.map((item) => (
                                            <option key={item.GroupCode} value={item.GroupCode}>
                                                {item.GroupName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button className="admin-button wid-200" onClick={() => loadSubCategory()}>
                                    Load
                                </button>
                            </div>
                        </div>
                        {
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Image</th>
                                                <th>Part Number</th>
                                                <th>Product Name</th>
                                                <th>Description</th>
                                                <th>Action</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td colSpan={6}>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Search product..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            </InputGroup>
                                            </td>
                                        </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{index + 1}</td>
                                                            <td><img style={{width: 150}} src={emp.Img} className="img-fluid" /></td>
                                                            <td>{emp.SubGroupCode}</td>
                                                            <td>{emp.SubGroupName}</td>
                                                            <td>{emp.Description}</td>
                                                            <td>
                                                            <button className="admin-button wid-200" onClick={() => goToProductPage(emp.SubGroupId)}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                          }                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default HomePage;
